<template>
<div>
    <div class="card-body">
        <b-row>
            <b-col md="12">
                <div class="pull-right">
                    <b-button v-b-modal.modalModules variant="themecolor" size="sm" @click.stop="loadModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}</b-button>
                </div>
            </b-col>
        </b-row>
        <b-table show-empty :items="companyModules" :fields="fields" v-if="companyModules" :empty-text="getEmptyText(count)" :busy="count == -1">
            <template v-slot:cell(name)="data">{{ data.item.module.name }} </template>
            <template v-slot:cell(createdAt)="data">{{ data.item.createdAt | date }} </template>
            <template v-slot:cell(actions)="row">
                <delete title="Module" :noRedirect="true" :hideText="true" :id="row.item.id" namespace="management" resource="modules" />
            </template>
            <template v-slot:table-busy>
                <PreLoader/>
            </template>
        </b-table>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalModules" ref="modules" :title="$t('management.moduletoevoegen')" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
        <b-form @submit="onSubmit" autocomplete="off">
            <!-- Form content -->
            <b-form-group label-cols label="Module" label-for="module_id">
                <b-form-select id="module_id" v-model="command.moduleId" @change="onChangeModule(command)">
                    <option value="">{{$t('management.selecteereenmodule')}}</option>
                    <option :key="index" :value="coreModule.id" v-for="(coreModule, index) in coreModules" >{{ coreModule.name }}</option>
                </b-form-select>
                <validation element="module_id" />
            </b-form-group>
            <!-- Form content -->
            <hr />
            <!-- Submit controls -->
            <b-row>
                <b-col md="12">
                    <b-button @click="$refs.modules.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                    <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                </b-col>
            </b-row>
            <!-- Submit controls -->
        </b-form>
    </b-modal>
    <!-- Modal Component -->
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from 'vuex'

//Import command
import Command from './command'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: 'modules',
    components: {PreLoader},
    data() {
        return {
            command: {},
            count: -1,
        }
    },
    computed: {
        fields() { 
            return [
                {
                    key: 'name',
                    label: this.$i18n.t('datatables.modulenaam'),
                    sortable: true
                },
                {
                    key: 'createdAt',
                    label: this.$i18n.t('datatables.aanmaakdatum'),
                    sortable: true
                },
                {
                    key: 'actions',
                    label: this.$i18n.t('datatables.acties')
                }
            ]
        },
        ...mapGetters({
            coreModules: 'core/modules'
        }),
        ...mapGetters({
            companyModules: 'management/modules'
        }),
    },
    methods: {
        ...mapActions('management',['all','find','create','update','delete']),
        loadModal(item) {
            let vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.command = new Command(item);
            vm.command.companyName = vm.$store.getters['management/company'].name;
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;
            let payload = {
                resource: 'modules',
                path: vm.$route.path,
                params: vm.command
            };

            let action = vm.create(payload);
            action.then( () => {
                vm.$store.dispatch('management/all', {
                    resource:'modules'
                });
                vm.$refs.modules.hide();
            });
        },
        onChangeModule(event) {
            let vm = this
            let found = vm.coreModules.filter(obj => {
                return obj.id === event.moduleId
            })
            if(found.length > 0) {
                vm.command.moduleName = found[0].name
            } else {
                vm.command.moduleName = ''
            }          
        },
        getEmptyText,
    },
    created() {
        let vm = this;
        vm.$store.dispatch('management/all', {
            resource: 'modules'
        });
        vm.$store.dispatch('core/all', {
            resource: 'modules'
        });
        vm.all({
            resource: 'modules'
        })
        .then((data) => {
            vm.count = data.result.length;
        });
    }
}
</script>